import { FetchTokenError, LocalDBInitError, NetworkConnectivityError } from '@/errors';

export const getLoginOperationalError = (error: FetchTokenError | LocalDBInitError | unknown) => {
  if (error instanceof FetchTokenError) {
    return 'We could not sign you in. Please contact Titleist support.';
  } else if (error instanceof LocalDBInitError) {
    return 'There was an issue preparing your app data. Please try again.';
  } else if (error instanceof NetworkConnectivityError) {
    return 'Network connection lost. Please check the connection and try again.';
  } else {
    return 'Something went wrong. Please try again.';
  }
};
